//
//
//
//
//
//
//
//
//

export default {
  props: ['error'],
  head: {
    bodyAttrs: {
      class: 'theme-dark'
    },
    title: 'Cashback Wmr Panel',
    meta: [{
      hid: 'Cashback Wmr Panel',
      name: 'Cashback Wmr Panel',
      content: 'Cashback Wmr Panel'
    }]
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/error.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/error.vue
// module chunks = 152